import { api } from "api";

/**
 * The driver wallet policy of one city.
 *
 * A DEDICATED ENDPOINT, NOT THE CITY FORM. The city form posts multipart and
 * saves through the generic mass-assign PATCH, which the API closes to these
 * five columns on purpose: every multipart value arrives as a string, and an
 * empty one in a DECIMAL column takes the whole patch down with a 500. These
 * columns decide what an order costs a driver. See api#104.
 *
 * @typedef {object} CityWalletPolicy
 * @property {number} id
 * @property {boolean} driver_wallet_enabled
 * @property {"shipping"|"driver_share"|"flat"} driver_wallet_fee_basis
 * @property {number} driver_wallet_default_percentage
 * @property {number} vendor_commission_default_percentage
 * @property {number} driver_wallet_flat_fee
 * @property {number} driverCount The drivers this city has.
 * @property {number} emptyWalletCount How many of them hold no balance.
 */

/**
 * @param {number|string} cityId
 * @returns {Promise<CityWalletPolicy>}
 */
export const getCityWallet = async (cityId) => {
    const response = await api.get(`api/city/${cityId}/driver-wallet`);
    return response.data;
};

/**
 * @param {{cityId: number|string, enabled?: boolean, feeBasis?: string,
 *   driverPercentage?: number, vendorPercentage?: number, flatFee?: number}} payload
 * @returns {Promise<CityWalletPolicy>}
 */
export const updateCityWallet = async ({ cityId, ...body }) => {
    const response = await api.patch(`api/city/${cityId}/driver-wallet`, body);
    return response.data;
};
